import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

function cleanNumber(s) {
    return (s || "").replace(/[^0-9+]/g, "").replace(/^\+/, "");
}

function buildWhatsAppUrl(phone, message) {
    const cleaned = cleanNumber(phone);
    if (!cleaned) return null;
    const text = encodeURIComponent(message || "");
    return `https://wa.me/${cleaned}${text ? `?text=${text}` : ""}`;
}

export default function WhatsAppFAB({ contextMessage }) {
    const { user } = useAuth();
    const [phone, setPhone] = useState("");
    const [officeName, setOfficeName] = useState("");

    useEffect(() => {
        api.get("/settings")
            .then((r) => {
                setPhone(r.data?.office_whatsapp || "");
                setOfficeName(r.data?.office_name || "Oficina");
            })
            .catch(() => {});
    }, []);

    if (!phone) return null;

    const message = contextMessage || `Hola, soy ${user?.name || "operario"}.`;
    const url = buildWhatsAppUrl(phone, message);
    if (!url) return null;

    return (
        <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-5 right-5 z-50 group"
            data-testid="whatsapp-fab"
            aria-label={`WhatsApp ${officeName}`}
            title={`Escribir a ${officeName} por WhatsApp`}
        >
            <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 group-hover:opacity-60 animate-ping" />
            <div className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-xl hover:scale-110 transition">
                <svg viewBox="0 0 32 32" width="28" height="28" fill="currentColor" aria-hidden="true">
                    <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.5 0 1.69-.358 2.034-.916.115-.214.215-.43.32-.645v-.515c-.054-.114-.243-.184-.4-.27a8.7 8.7 0 0 0-.974-.6.84.84 0 0 0-.426-.144Zm-2.97 7.045a9.376 9.376 0 0 1-5.297-1.626l-3.703.97.985-3.602a9.388 9.388 0 1 1 8.014 4.258Zm.001-20.668a11.252 11.252 0 0 0-9.738 16.85l-1.27 4.633 4.747-1.245a11.243 11.243 0 0 0 6.262 1.92 11.258 11.258 0 1 0-.001-22.158Z" />
                </svg>
            </div>
        </a>
    );
}
